import { memberCalls2Url } from '@helpers/httpHelpers'
import axios from 'axios'

const getPeriod = ({ country2alpha, joinPeriod }: { country2alpha: string; joinPeriod: string }) => {
    const url = memberCalls2Url({
        path: '/topup/period'
    })

    return axios.post(url, {
        country: country2alpha,
        joinPeriod: joinPeriod,
        system: 'AO'
    })
}

export const periodAPI = {
    getPeriod
}
